var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h100"},[_c('transition',{attrs:{"name":_vm.setTransitionName,"mode":"out-in"}},[_c('keep-alive',{attrs:{"include":_vm.keepAliveNameList}},[_c('router-view',{key:_vm.refreshRouterViewKey})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }